import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'pcp',
})
export class PCPPipe implements PipeTransform {
  transform(value: string): string {
    return value && value.replace(/^(\d{4})(\d)/, '$1-$2')
  }
}
